import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatAccountNumber from "../../unit/formatAccountNumber";
import formatDate from "../../unit/formatDate";
const TableCellRight = styled(TableCell)({ textAlign: "right" });

const CustomSummaryPaymentAccountList = ({ ...props }) => {
  const userId = props.userId;
  const plaidAccountList = props.plaidAccountList ? props.plaidAccountList : [];
  const plaidAccount = props.plaidAccount ? props.plaidAccount : [];
  const paymentAccountData = props.paymentAccountData
    ? props.paymentAccountData
    : [];

  return (
    <div key={"customsummarypaymentaccount" + userId}>
      <CustomTableContainer commponent={CustomPaper}>
        <CustomTable
          key={"payment_account_connected" + userId}
          stickyHeader
          id="table-customer-summary-payment-source-list"
        >
          <TableHead>
            <TableRow>
              <TableCell className="hm-table-header">Account ID</TableCell>

              <TableCell className="hm-table-header">Institution</TableCell>
              <TableCell className="hm-table-header">Routing Number</TableCell>
              <TableCell sx={{ width: "150px" }} className="hm-table-header">
                Account Number
                <br />
                (Last 4 Digits)
              </TableCell>
              <TableCell className="hm-table-header">Account Type</TableCell>
              <TableCell className="hm-table-header">Status</TableCell>
              <TableCell className="hm-table-header">Connection</TableCell>
              <TableCell className="hm-table-header">Purpose</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paymentAccountData == undefined ||
            paymentAccountData.length == 0 ||
            paymentAccountData == null ? (
              <TableRow>
                <TableCell colSpan={8}>No payment account connected</TableCell>
              </TableRow>
            ) : (
              paymentAccountData.map((item: any) => (
                <TableRow
                  key={
                    `cspa_` +
                    item.iApplicationId +
                    `_` +
                    item.id +
                    `_` +
                    item.sAccountNumber +
                    `_` +
                    item.purpose
                  }
                >
                  <TableCell>{item.iAccountId}</TableCell>

                  <TableCell>{item.sInstitutionName}</TableCell>
                  <TableCell>{formatDate(item.sRoutingNumber)}</TableCell>
                  <TableCell>
                    {formatAccountNumber(item.sAccountNumber)}
                  </TableCell>
                  <TableCell>{item.sAccountType}</TableCell>
                  <TableCell>{item.sStatus}</TableCell>
                  <TableCell>
                    {item.sSource == "plaid" || item.sSource == "Plaid"
                      ? `Plaid`
                      : `Manual`}
                  </TableCell>
                  <TableCell>{item.purpose}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </div>
  );
};

export default CustomSummaryPaymentAccountList;
